import React from 'react';
import { Routes, Route } from 'react-router-dom';
import FoundationsList from './FoundationsList';
import Foundation from './FoundationsDetails';

function FoundationsIndex() {
  return (
    <>
      <Routes>
        <Route path="/" element={<FoundationsList />} />
        <Route path="details/:id" element={<Foundation />} />
        <Route path="details/create" element={<Foundation />} />
      </Routes>
    </>
  );
}

export default FoundationsIndex;
